var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSearch,
              expression: "showSearch",
            },
          ],
          ref: "queryForm",
          attrs: {
            model: _vm.queryParams,
            size: "small",
            inline: true,
            "label-width": "78px",
          },
        },
        [
          _c("dt-form-item", {
            attrs: {
              label: _vm.searchParamFormKey.label,
              inputType: _vm.searchParamFormKey.type,
              propKey: _vm.searchParamFormKey.propKey,
              options: _vm.searchParamFormKey.options,
              componentAttr: _vm.searchParamFormKey.attrs,
              valueRepeat: _vm.searchParamFormKey.valueRepeat,
            },
            on: {
              clear: function ($event) {
                return _vm.getList()
              },
            },
            model: {
              value: _vm.queryParams.formKey,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "formKey", $$v)
              },
              expression: "queryParams.formKey",
            },
          }),
          _c("dt-form-item", {
            attrs: {
              label: "工单状态",
              inputType: "select",
              options: _vm.statusArr,
              componentAttr: {
                clearable: true,
                valueKey: "label",
                placeholder: "工单状态",
              },
            },
            on: {
              clear: function ($event) {
                return _vm.getList()
              },
            },
            model: {
              value: _vm.queryParams.status,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "status", $$v)
              },
              expression: "queryParams.status",
            },
          }),
          _c("select-tree", {
            ref: "selectTree",
            attrs: {
              defaultKeys: _vm.defaultKeys,
              title: "所属组织",
              options: _vm.shopOptions,
              defaultProps: _vm.defaultProps,
            },
          }),
          _c("dt-form-item", {
            attrs: {
              label: "创建时间",
              inputType: "date-picker",
              componentAttr: {
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "yyyy-MM-dd",
                clearable: false,
                "unlink-panels": true,
              },
            },
            on: {
              clear: function ($event) {
                return _vm.getList()
              },
            },
            model: {
              value: _vm.datePicker,
              callback: function ($$v) {
                _vm.datePicker = $$v
              },
              expression: "datePicker",
            },
          }),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-search",
                    size: "mini",
                  },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v(" 搜索 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.resetQuery },
                },
                [_vm._v(" 重置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticClass: "mb8",
          attrs: { gutter: 10, type: "flex", justify: "space-between" },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-radio-group",
                {
                  directives: [
                    { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
                  ],
                  on: { change: _vm.selectedDelongUser },
                  model: {
                    value: _vm.belongUser,
                    callback: function ($$v) {
                      _vm.belongUser = $$v
                    },
                    expression: "belongUser",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "" } }, [
                    _vm._v("全部工单"),
                  ]),
                  _c("el-radio-button", { attrs: { label: 1 } }, [
                    _vm._v("我的待处理"),
                  ]),
                  _c("el-radio-button", { attrs: { label: 2 } }, [
                    _vm._v("我的已处理"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["workOrderList_batchCloseWorkOrder"],
                      expression: "['workOrderList_batchCloseWorkOrder']",
                    },
                  ],
                  attrs: { type: "primary", plain: "", size: "small" },
                  on: { click: _vm.handleCloseOrder },
                },
                [_vm._v(" 批量关闭 ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["workOrderList_exportWorkOrders"],
                      expression: "['workOrderList_exportWorkOrders']",
                    },
                  ],
                  attrs: { type: "primary", plain: "", size: "small" },
                  on: { click: _vm.handleExport },
                },
                [_vm._v(" 导出 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { "margin-top": "10px" },
          attrs: { data: _vm.workOrderList },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "45",
              align: "center",
              selectable: _vm.handleDisable,
            },
          }),
          _c("el-table-column", {
            attrs: { label: "编码", align: "center", prop: "code" },
          }),
          _c("el-table-column", {
            attrs: { label: "工单名称", align: "center", prop: "name" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "触发问卷",
              align: "center",
              prop: "formName",
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              align: "center",
              prop: "id",
              width: "80px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: row.status ? "info" : "" } },
                      [
                        _vm._v(
                          " " + _vm._s(row.status ? "已关闭" : "处理中") + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "品牌", align: "center", prop: "brandName" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "大区",
              align: "center",
              prop: "parentPartitionName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "分区",
              align: "center",
              prop: "locatedPartitionName",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "门店", align: "center", prop: "shopName" },
          }),
          _c("el-table-column", {
            attrs: { label: "组织编码", align: "center", prop: "shopCode" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "处理人",
              align: "center",
              prop: "transactorName",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.transactorName.join("，")) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", prop: "createTime" },
          }),
          _c("el-table-column", {
            attrs: { label: "关闭时间", align: "center", prop: "closeTime" },
          }),
          _c("el-table-column", {
            directives: [
              {
                name: "permission",
                rawName: "v-permission",
                value: ["workOrderList_detail"],
                expression: "['workOrderList_detail']",
              },
            ],
            attrs: {
              label: "操作",
              align: "center",
              "class-name": "small-padding fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["workOrderList_detail"],
                            expression: "['workOrderList_detail']",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          type: "text",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v(" 查看 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.current,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "current", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c("order-operator", {
        ref: "operatorForm",
        attrs: { title: "关闭原因", placeholder: "请输入关闭原因" },
        on: { handleConfirm: _vm.handleCloseOrderConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }